
module.exports = {
    CSS_UNITS : 96.0 / 72.0,
    DEFAULT_SCALE_VALUE : 'auto',
    DEFAULT_SCALE : 1.0,
    UNKNOWN_SCALE : 0,
    MAX_AUTO_SCALE : 1.25,
    SCROLLBAR_PADDING : 40,
    VERTICAL_PADDING : 5
}